var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash-filled_svg__clip0_358_3241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4h6a1 1 0 110 2H1a1 1 0 010-2h6V1a1 1 0 011-1h8a1 1 0 011 1v3zm-2-2H9v2h6V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82 23.193a3.01 3.01 0 01-.95-1.979L2.926 8h18.148l-.944 13.214A3.01 3.01 0 0117.138 24H6.862a3.01 3.01 0 01-2.042-.807z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash-filled_svg__clip0_358_3241"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTrashFilled;